/* eslint no-console: 0 */

import MarkdownScript from 'helpers/markdownScript';
import metadataFile from './index.md';
import extensionActivitiesFile from './extensionActivities/extensionActivities.md';
import programPrepFile from './programPrep/programPrep.md';
import level1Prepfile from './sections/00_prep/level1_prep.md';
import funFile from './fun.md';
import imageThumb from './images/emergencyPreparednessSquad.png';
import trialImageThumb from './images/emergencyPreparednessSquadTrial.png';
import expiredImageThumb from './images/emergencyPreparednessSquadExpired.png';
import config from './config';

// Preload image functions
import { preloadGameShow } from './sections/30_gameShow/gameShowSection';

import './theme.scss';

const md = new MarkdownScript(metadataFile);

const levels = {
  prep: {
    deck: require('./levelPrep')
  },
  1: {
    thumbnail: require('./images/level-1_start.png'),
    overviewThumbnail: require('./images/overview/level-1_start.png'),
    deck: require('./level1'),
    prep: new MarkdownScript(level1Prepfile),
    levelName: 'Know the Risks'
  },
  completed: {
    deck: require('./levelCompleted')
  }
};

const program = {
  id: 'epsHybridAssembly',
  title: md.getSectionAsString('Title - Short'),
  longTitle: md.getSectionAsString('Title - Long'),
  thumbnailImage: imageThumb,
  trialImageThumb,
  expiredImageThumb,
  longDescription: md.getSectionAsString('Description - Long'),
  shortDescription: md.getSectionAsString('Description - Short'),
  levelsDescription: md.getSectionAsString('Description - Levels'),
  levels,
  extensionActivitiesMd: new MarkdownScript(extensionActivitiesFile),
  programPrepMd: new MarkdownScript(programPrepFile),
  funMd: new MarkdownScript(funFile),
  preload: ({ level }) => {
    console.log(`Preloading assets for Level ${level}`);

    preloadGameShow();
  },
  config,
  limitToRegions: []
};

export default program;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/index.js